import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from '../images/The_Challenge_of_everest_logo.jpg'; // Replace with your actual logo path
import "../App.css";

const NavbarComponent = () => {
  return (
    <Navbar
      bg="light"
      variant="light"
      expand="lg"
      className="sticky-top custom-navbar"
    >
      <Container>
        {/* Logo aligned to the left */}
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            alt="Logo"
            className="navbar-logo"
            style={{ height: "120px" }} // Adjust the logo size as needed
          />
        </Navbar.Brand>

        {/* Toggle button for mobile view */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        {/* Navigation links aligned to the right */}
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className="nav-item">
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/Team" className="nav-item">
              Our Team
            </Nav.Link>
            <Nav.Link as={Link} to="/GameInfo" className="nav-item">
              How To Play
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className="nav-item">
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
